import { useState } from '#imports'

// The stop the camera settled on: BGMap writes it, the journey card waits on it. Module
// scope and client-write-only, like useMapReady; `null` is "nothing has flown yet"
export function useJourneyCamera() {
  const landedStop = useState<number | null>('landedStop', () => null)
  return { landedStop }
}
